import Vue from 'vue'

import Localized from '@/components/Localized.tsx'
import Instruction from '../elements/Instruction.vue'
import LikertItem from '../elements/likert/Item.vue'
import LikertScale from '../elements/likert/Scale.vue'
import LikertScaleHeader from '../elements/likert/ScaleHeader.vue'
import Steps from '../elements/Steps.vue'
import YesOrNo from '../elements/YesOrNo.vue'
import { allRequiredVariablesArePresent, missingRequiredVariables, Requirable } from '../utils'

export default Vue.extend({
  components: {
    Instruction,
    LikertItem,
    LikertScale,
    LikertScaleHeader,
    Localized,
    Steps,
    YesOrNo,
  },
  computed: {
    firstEmptyRequiredVariable(): string | undefined {
      return [...this.missingRequiredVariables].shift()
    },
    missingRequiredVariables(): string[] {
      if (this.settings && this.settings.steps) {
        return missingRequiredVariables(this.settings.steps as Requirable[], this.value)
      } else {
        return []
      }
    },
    requiredValuesArePresent(): boolean {
      if (this.settings && this.settings.steps) {
        return allRequiredVariablesArePresent(this.settings.steps as Requirable[], this.value)
      } else {
        return true
      }
    },
    patient(): any {
      return this.$store.getters.currentCase.patient
    },
    genderOfPatient(): string | null {
      const patient = this.patient
      return patient.gender && patient.gender.toLowerCase()
    },
  },
  data() {
    return { settings: { steps: [] } }
  },
  props: {
    disabled: {
      default: false,
      type: Boolean,
    },
    value: {
      default: () => ({}),
      required: false,
      type: Object,
    },
  },
})
